export default "__VITE_ASSET__Bzod2Esx__"